<template>
    <div>
        <despesas
            v-show="mostrarDespesas"
            :despesas="despesas"
            :servicos="obterServicos()"
            :temAcessoDetalhar="$temAcessoView('DESP-GERAIS-REQ-00')"
            :temAcessoInserir="$temAcessoView('DESP-GERAIS-REQ-01')"
            @atualizar="obterDespesas()"
            @atualizarFiltro="atualizarFiltro($event)"
        ></despesas>
        <router-view></router-view>
    </div>
</template>

<script>
import Despesas from '@/app/despesasgerais/componentes/despesas/Despesas.vue';
import DespesasServicos from './DespesasServicos'

export default {
    data() {
        return {
            despesas: [],
            filtro: {}
        }
    },

    components: {
        Despesas
    },

    computed: {
        mostrarDespesas() {
            return this.$route.name === 'DespesasGerais_Requisitantes_Despesas'
        }
    },

    methods: {
        obterServicos() {
            return DespesasServicos
        },

        atualizarFiltro(filtro) {
            this.filtro = filtro
            this.obterDespesas()
        },

        obterDespesas() {
            this.$store.dispatch('addRequest')
            DespesasServicos.obterTodos(this.filtro).then(response => {
                if (response) {
                    if (response.success) {
                        this.despesas = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },
    },

    created() {
        // this.obterDespesas()
    },

    watch: {
        $route(to) {
            if (to.name === 'DespesasGerais_Requisitantes_Despesas') {
                this.obterDespesas()
                this.$store.dispatch('setRecarregar', false)
            }
        }
    }
}

</script>